import { SVGProps } from "react";

export function WalletIcon({
  size = 24,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4101 9.86015C20.3518 9.85745 20.2934 9.85645 20.2351 9.85715H17.8C15.808 9.85715 14.1021 11.4382 14.1021 13.5002C14.1021 15.5622 15.8081 17.1432 17.8011 17.1432H20.234C20.2954 17.1438 20.3537 17.1425 20.4091 17.1392C20.8201 17.1125 21.2074 16.9375 21.4992 16.6467C21.7909 16.3559 21.9671 15.9691 21.9951 15.5582C21.9991 15.4992 21.9991 15.4362 21.9991 15.3782V11.6222C21.9991 11.5642 21.9991 11.5012 21.9951 11.4422C21.9671 11.0314 21.791 10.6447 21.4995 10.3539C21.208 10.0631 20.8209 9.88805 20.4101 9.86115M17.5871 14.4722C18.1001 14.4722 18.5171 14.0382 18.5171 13.5012C18.5171 12.9642 18.1001 12.5302 17.5871 12.5302C17.0741 12.5302 16.6581 12.9642 16.6581 13.5012C16.6581 14.0382 17.0731 14.4722 17.5871 14.4722Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.234 18.6C20.2675 18.5988 20.3008 18.6055 20.3312 18.6196C20.3617 18.6337 20.3884 18.6547 20.4092 18.6809C20.43 18.7072 20.4444 18.738 20.4511 18.7708C20.4579 18.8037 20.4568 18.8377 20.448 18.87C20.254 19.562 19.947 20.152 19.454 20.648C18.733 21.375 17.818 21.698 16.688 21.851C15.59 22 14.188 22 12.416 22H10.379C8.608 22 7.205 22 6.107 21.851C4.977 21.698 4.062 21.375 3.341 20.648C2.62 19.923 2.3 19 2.148 17.862C2 16.754 2 15.34 2 13.555V13.445C2 11.66 2 10.245 2.148 9.139C2.3 8 2.62 7.08 3.34 6.351C4.061 5.625 4.976 5.301 6.106 5.149C7.205 5 8.608 5 10.379 5H12.416C14.187 5 15.59 5 16.688 5.149C17.818 5.302 18.733 5.625 19.454 6.351C19.947 6.848 20.254 7.438 20.448 8.131C20.4566 8.16328 20.4575 8.19714 20.4507 8.22984C20.4439 8.26255 20.4295 8.2932 20.4087 8.31935C20.3879 8.3455 20.3613 8.36641 20.3309 8.38042C20.3006 8.39442 20.2674 8.40113 20.234 8.4H17.801C15.067 8.4 12.658 10.577 12.658 13.5C12.658 16.423 15.068 18.6 17.802 18.6H20.234ZM5.614 8.886C5.51879 8.88639 5.42459 8.90554 5.33678 8.94233C5.24897 8.97913 5.16927 9.03287 5.10222 9.10047C5.03518 9.16807 4.98211 9.24821 4.94604 9.33633C4.90997 9.42444 4.89161 9.51879 4.892 9.614C4.892 10.017 5.215 10.343 5.614 10.343H9.47C9.87 10.343 10.193 10.017 10.193 9.614C10.1935 9.42163 10.1177 9.2369 9.98213 9.10041C9.84657 8.96391 9.66237 8.88679 9.47 8.886H5.614Z"
        fill={color}
      />
      <path
        d="M7.77686 4.02386L9.73486 2.58086C10.2459 2.20327 10.8645 1.99951 11.4999 1.99951C12.1352 1.99951 12.7539 2.20327 13.2649 2.58086L15.2339 4.03186C14.4099 3.99986 13.4899 3.99986 12.4829 3.99986H10.3129C9.39086 3.99986 8.54386 3.99986 7.77686 4.02386Z"
        fill={color}
      />
    </svg>
  );
}
